import { Component, OnInit, ViewChild } from "@angular/core";
import { SchoolService } from "../../../shared/services/school.service";
import { DataService_Student_Alerts } from "./shared/data.service";
import { DynamicValueRequest } from "./shared/DynamicValueRequest";
import { StudentAlertTableRequest } from "./shared/StudentAlertTableRequest";
import { StudentAlertsTableComponent } from "./student-alerts-table/student-alerts-table.component";
import * as moment from "moment";

@Component({
	selector: "app-student-alerts",
	templateUrl: "./student-alerts.component.html",
	styleUrls: ["./student-alerts.component.css"],
})
export class StudentAlertsComponent implements OnInit {
	constructor(private schoolService: SchoolService, private studentAlertService: DataService_Student_Alerts) {}

	ngOnInit(): void {
		this.loadSchoolist();
	}

	////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////

	MainLoading: any = false;

	//Selector
	ContainerID: any;
	lstContainer: any = [];

	DistrictID: any;
	lstDistrict: any = [];

	SchoolGroupID: any;
	lstSchoolGroup: any = [];

	FacilityID: any;
	lstFacility: any = [];

	DynamicGroup: any;
	lstDynamicGroup: any = [];

	DynamicValueID: any;
	lstDynamicGroupValues: any = [];

	//Data passed to table (gets updated by onSearch())
	lstIncidents: any = [];

	DisableSearch: any = false;

	@ViewChild(StudentAlertsTableComponent)
	tableRef: StudentAlertsTableComponent;

	AlertDesc: any = "";

	IncludeDeactivated: boolean = false;

	////////////////////////////////////////////////////

	////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////

	loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstContainer = response;

				this.lstContainer.unshift({
					SchoolID: -1,
					SchoolName: "Facility",
				});
				this.lstContainer.unshift({
					SchoolID: -2,
					SchoolName: "Container",
				});
				this.lstContainer.unshift({
					SchoolID: -3,
					SchoolName: "All Schools",
				});

				this.ContainerID = this.lstContainer[0].SchoolID;

				//Load other lists
				this.loadDynamicGroups();
			},
			(error) => {}
		);
	}

	//
	//Get dynamic groups or other values based on container
	//
	loadDynamicGroups() {
		//Reset lists
		this.lstDistrict = [];
		this.lstSchoolGroup = [];
		this.lstFacility = [];
		this.lstDynamicGroup = [];
		this.lstDynamicGroupValues = [];

		//Reset values
		this.DistrictID = null;
		this.SchoolGroupID = null;
		this.FacilityID = null;
		this.DynamicGroup = null;
		this.DynamicValueID = null;
		this.AlertDesc = "";

		//District
		if (this.ContainerID == -3) {
			this.DistrictID = -1;
			//   var result = this.studentAlertService.DistrictSelectList();
			//   result.subscribe(
			//     response => {
			//       this.lstDistrict = response;

			//       this.lstDistrict.unshift({
			//         DistrictID: -1,
			//         DistrictName: "All"
			//       })

			//       this.DistrictID = this.lstDistrict[0].DistrictID;
			//     },
			//     error => {
			//     }
			//   )
		}
		//Container
		else if (this.ContainerID == -2) {
			var result = this.studentAlertService.SchoolGroupSelectList();
			result.subscribe(
				(response) => {
					this.lstSchoolGroup = response;

					this.lstSchoolGroup.unshift({
						SchoolGroupID: -1,
						SchoolGroupDesc: "All",
					});

					this.SchoolGroupID = this.lstSchoolGroup[0].SchoolGroupID;
				},
				(error) => {}
			);
		}
		//Facility
		else if (this.ContainerID == -1) {
			var result = this.studentAlertService.FacilitySelectList();
			result.subscribe(
				(response) => {
					this.lstFacility = response;

					this.FacilityID = this.lstFacility[0].FacilityID;
				},
				(error) => {}
			);
		}
		//School
		else {
			var result = this.studentAlertService.DynamicGroupSelectList(1);
			result.subscribe(
				(response) => {
					this.lstDynamicGroup = response;

					this.DynamicGroup = this.lstDynamicGroup[0];

					this.loadDynamicValues();
				},
				(error) => {}
			);
		}
	}

	loadDynamicValues() {
		let parms: DynamicValueRequest = {
			DGSQL: this.DynamicGroup.DynamicGroupSQL,
			SchoolID: this.ContainerID,
		};

		var result = this.studentAlertService.DynamicValueSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstDynamicGroupValues = response;

				this.DynamicValueID = this.lstDynamicGroupValues[0].ListID;
			},
			(error) => {}
		);
	}

	loadAlertDesc() {
		var result = this.studentAlertService.AlertSelectDesc(this.DynamicValueID);
		result.subscribe(
			(response) => {
				var data: any = response;

				if (data.length > 0) {
					this.AlertDesc = response[0].str;
				} else {
					this.AlertDesc = "";
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////////////

	////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////
	onSearch() {
		this.MainLoading = true; //Set table to loading
		this.tableRef.loading = true;

		this.lstIncidents = [];

		//
		// Update lstIncidents (and pass to table)
		//
		var DGID = 0;
		var DVID = 0;

		//Normal dynamic group values
		if (this.ContainerID > 0) {
			DGID = this.DynamicGroup.DynamicGroupID;
			DVID = this.DynamicValueID;
		}
		//District?

		//School Group
		else if (this.ContainerID == -2) {
			DGID = this.SchoolGroupID;
		}
		//Facility
		else if (this.ContainerID == -1) {
			DGID = this.FacilityID;
		}

		//Format dates
		var fsDate: string = moment(this.tableRef.StartDate).format("MM/DD/YYYY");
		var feDate: string = moment(this.tableRef.EndDate).format("MM/DD/YYYY");
		// var fsTime: string = moment(this.tableRef.StartTime).format("MM/DD/YYYY HH:mm:ss");
		// var feTime: string = moment(this.tableRef.EndTime).format("MM/DD/YYYY HH:mm:ss");

		//Check that dates are valid
		if (
			fsDate.toLowerCase().indexOf("invalid") != -1 ||
			feDate.toLowerCase().indexOf("invalid") != -1 //||
			// fsTime.toLowerCase().indexOf("invalid") != -1 ||
			// feTime.toLowerCase().indexOf("invalid") != -1
		) {
			return;
		}

		// var Wrap = this.tableRef.WrapTime == true ? 1 : 0;

		let parms: StudentAlertTableRequest = {
			ContainerID: this.ContainerID,
			DynamicGroupID: DGID,
			DynamicGroupValue: DVID,
			StartDate: fsDate,
			EndDate: feDate,
			// StartTime: fsTime,
			// EndTime: feTime,
			// WrapTime: Wrap,
			IncludeDeactivated: this.IncludeDeactivated == true ? 1 : 0,
		};

		var result = this.studentAlertService.StudentAlertTableSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstIncidents = response;

				this.MainLoading = false; //Stop forcing table to be loading from main(it may or may not still be loading)
				this.tableRef.loading = false;
			},
			(error) => {}
		);
	}
	////////////////////////////////////////////////////

	////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////
	onContainerChanged(val) {
		this.ContainerID = val;

		//Load options/dynamic groups and values
		this.loadDynamicGroups();
	}

	onDynamicGroupChanged(val) {
		this.DynamicGroup = val;

		//Load values
		this.loadDynamicValues();
	}

	onDynamicValueChanged(val) {
		this.DynamicValueID = val;

		this.AlertDesc = "";

		//
		// Alerts, Get description
		//
		if (this.DynamicGroup.DynamicGroupID == 28) {
			this.loadAlertDesc();
		}
	}

	onDisableSearchChange(val) {
		this.DisableSearch = val;
	}
	////////////////////////////////////////////////////

	ShowDesc() {
		if (this.DynamicGroup == null) {
			return false;
		} else {
			if (this.DynamicGroup.DynamicGroupID == 28 && this.AlertDesc != "") {
				return true;
			} else {
				return false;
			}
		}
	}
}
